import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>MEES HOLDINGS INC</h3>
            <p>Authorized reseller of professional SMS marketing services with full compliance commitment.</p>
            <p><strong>Address:</strong><br />
            2022 E 9TH ST<br />
            BROOKLYN, NY 11223<br />
            United States</p>
            <p><strong>EIN:</strong> 93-4196857</p>
          </div>
          <div className="footer-section">
            <h3>Services</h3>
            <p><Link to="/services">SMS Marketing</Link></p>
            <p><Link to="/services">A2P Messaging</Link></p>
            <p><Link to="/services">Campaign Management</Link></p>
            <p><Link to="/services">Compliance Consulting</Link></p>
          </div>
          <div className="footer-section">
            <h3>Legal</h3>
            <p><Link to="/privacy">Privacy Policy</Link></p>
            <p><Link to="/terms">Terms of Service</Link></p>
            <p><Link to="/sms-terms">SMS Terms</Link></p>
            <p><Link to="/compliance">Compliance</Link></p>
            <p><Link to="/verification">Business Verification</Link></p>
            <p><Link to="/opt-out">Opt-Out</Link></p>
          </div>
          <div className="footer-section">
            <h3>Contact</h3>
            <p><Link to="/contact">Get in Touch</Link></p>
            <p><Link to="/support">Support</Link></p>
            <p>Email: info@meesmarketing.com</p>
            <p>Support: support@meesmarketing.com</p>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} MEES HOLDINGS INC. All rights reserved. | Registered SMS Marketing Service Provider</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;